import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getRecentDaycare } from '../../../feature/dashboard/DashboardSlice'

const colors = ['#6366f1', '#ec4899', '#22c55e', '#f59e0b', '#3b82f6', '#8b5cf6', '#94a3b8']
const bgs = ['#eef2ff', '#fdf2f8', '#f0fdf4', '#fffbeb', '#eff6ff', '#f5f3ff', '#f8fafc']

const Empty = ({ text }) => (
    <div style={{ textAlign: 'center', padding: '32px 0', color: '#bbb' }}>
        <div style={{ fontSize: 32, marginBottom: 8 }}>🏫</div>
        <div style={{ fontSize: 13, fontWeight: 500 }}>{text}</div>
    </div>
)

function RecentlyAdded({ month, year }) {
    const dispatch = useDispatch()
    const { recentDaycare } = useSelector((state) => state.dashboards)

    useEffect(() => { dispatch(getRecentDaycare({ month, year })) }, [month, year])

    const list = Array.isArray(recentDaycare) ? recentDaycare : []

    return (
        <div style={{ background: '#fff', borderRadius: 12, padding: '20px 20px', border: '1px solid #f0f0f0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', height: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: '#111' }}>Recently Added</div>
                <span style={{ fontSize: 13, color: '#6366f1', cursor: 'pointer', fontWeight: 500 }}>View all</span>
            </div>
            {list.length === 0 ? <Empty text="No daycares added for this period" /> : (
                <div style={{ minHeight: "320px", height:"40vh", overflowY: "auto", display: 'flex', flexDirection: 'column', gap: 14 }}>
                    {list.map((d, i) => {
                        const initials = (d.daycareName || d.name || '??').slice(0, 2).toUpperCase()
                        const status = d.status || 'Active'
                        return (
                            <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <div style={{ width: 38, height: 38, borderRadius: 10, background: bgs[i % bgs.length], color: colors[i % colors.length], fontWeight: 700, fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{initials}</div>
                                    <div>
                                        <div style={{ fontWeight: 600, fontSize: 13, color: '#111' }}>{d.daycareName || d.name}</div>
                                        <div style={{ fontSize: 12, color: '#aaa' }}>{d.location || d.city || ''}{d.lastActivity ? ` • ${d.lastActivity}` : ''}</div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, fontWeight: 500, color: status === 'Active' ? '#22c55e' : '#94a3b8' }}>
                                    <span style={{ width: 7, height: 7, borderRadius: '50%', background: status === 'Active' ? '#22c55e' : '#94a3b8', display: 'inline-block' }} />
                                    {status}
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default RecentlyAdded
